export class Retailer {
    constructor(public id: number, public name: string, public siteLink?: string) {}
}
